import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Home", href: "/#top", id: "home" },
  { label: "What We Do", href: "/#what-we-do", id: "what-we-do" },
  { label: "Available Rooms", href: "/#rooms", id: "rooms" },
  { label: "Work With Us", href: "/#work-with-us", id: "work-with-us" },
  { label: "Contact", href: "/#contact", id: "contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-[#EBEBEB]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-16 sm:h-20">
        <a href="/#top" data-testid="nav-logo" className="flex items-center">
          <img src="/logo-512.png" alt="Shonta Solutions LLC" className="h-11 sm:h-14 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-desktop">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={`nav-link-${link.id}`}
              className="text-sm font-semibold text-[#555] hover:text-[#FF5A5F] transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href="/#contact"
            data-testid="nav-cta-button"
            className="bg-[#FF5A5F] hover:bg-[#E0484D] text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors duration-200 shadow-[0_4px_14px_rgba(255,90,95,0.35)]"
          >
            Contact Us for Housing
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 text-[#222]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden bg-white border-t border-[#EBEBEB] px-5 py-4 space-y-1" data-testid="nav-mobile">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={`nav-mobile-link-${link.id}`}
              onClick={() => setOpen(false)}
              className="block py-2.5 text-base font-semibold text-[#333] hover:text-[#FF5A5F]"
            >
              {link.label}
            </a>
          ))}
          <a
            href="/#contact"
            data-testid="nav-mobile-cta-button"
            onClick={() => setOpen(false)}
            className="block mt-2 text-center bg-[#FF5A5F] text-white font-bold px-5 py-3 rounded-full"
          >
            Contact Us for Housing
          </a>
        </nav>
      )}
    </header>
  );
}
